import React from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './CountryOriginSection.style'

const CountryOriginSection = () => {
  const classes = useStyles()

  const { championship } = useSelector((state) => state.championships)
  const { countryName } = championship

  return (
    <SectionBlock title='Región / País' className={classes.container}>
      <Typography variant='h6'>{countryName}</Typography>
    </SectionBlock>
  )
}

export default CountryOriginSection
